import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  ADJUST_QUANTITY,
  CLEAR_CART,
} from "../cart/cartActions";

import { deepEqual } from "./utils";

const CART_META_KEY = "__cartMeta";

const initialState = {};

const stampCart = (nextState) => ({
  ...nextState,
  [CART_META_KEY]: { updatedAt: Date.now() },
});

// Helper function to check if two formData objects are equal



const isEqualFormData = (formData1, formData2) => {
  return deepEqual(formData1, formData2);
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART: {
      const { restaurantName, item } = action.payload;
      const restaurantCart = state[restaurantName] || [];
      const itemIndex = restaurantCart.findIndex(cartItem =>
        cartItem.id === item.id && (cartItem.menuMode || 'both') === (item.menuMode || 'both') && isEqualFormData(cartItem.formData, item.formData)
      );

      if (itemIndex >= 0) {
        // Item with the same formData already exists in the restaurant cart, update quantity
        const newCart = restaurantCart.map((cartItem, index) => {
          if (index === itemIndex) {
            return { 
              ...cartItem, 
              quantity: cartItem.quantity + item.quantity
            };
          }
          return cartItem;
        });
        return stampCart({ ...state, [restaurantName]: newCart });
      } else {
        // Item not in the cart or formData differs, add new item
        return stampCart({
          ...state,
          [restaurantName]: [...restaurantCart, item],
        });
      }
    }

    case REMOVE_FROM_CART: {
      const { restaurantName, uniqueId } = action.payload;
      const restaurantCart = state[restaurantName] || [];
      const newCart = restaurantCart.filter(cartItem => cartItem.uniqueId !== uniqueId);
      return stampCart({ ...state, [restaurantName]: newCart });
    }

    case ADJUST_QUANTITY: {
      const { restaurantName, uniqueId, quantity } = action.payload;
      const restaurantCart = state[restaurantName] || [];
      
      return stampCart({
        ...state,
        [restaurantName]: restaurantCart.map(item => 
          item.uniqueId === uniqueId ? { ...item, quantity: quantity } : item
        )
      });
    }

    case CLEAR_CART: {
      const { restaurantName } = action.payload;
      return stampCart({ ...state, [restaurantName]: [] });
    }

    default:
      return state;
  }
};

export default cartReducer;
